import React from 'react';
import { hero } from '../data';

const Hero = () => {
  return (
    <section id="top" className="relative h-[100svh] min-h-[100svh] flex flex-col overflow-hidden">
      {/* Background corp video, device-aware: landscape on desktop, 9:16 on mobile */}
      <video
        className="pointer-events-none absolute inset-0 w-full h-full object-cover hidden md:block"
        autoPlay muted loop playsInline preload="auto" poster="/hero-poster.jpg"
      >
        <source src="/hero-video.mp4" type="video/mp4" />
      </video>
      <video
        className="pointer-events-none absolute inset-0 w-full h-full object-cover block md:hidden"
        autoPlay muted loop playsInline preload="auto" poster="/hero-poster-vertical.jpg"
      >
        <source src="/hero-video-vertical.mp4" type="video/mp4" />
      </video>
      {/* Feathered gradient shadows so content stays legible */}
      <div className="pointer-events-none absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(9,12,26,0.78) 0%, rgba(9,12,26,0.42) 34%, rgba(9,12,26,0.55) 62%, rgba(9,12,26,0.92) 100%)' }} />
      <div className="pointer-events-none absolute inset-0" style={{ background: 'radial-gradient(130% 95% at 18% 58%, rgba(9,12,26,0.55), transparent 58%)' }} />
      <div className="pointer-events-none absolute inset-0" style={{ background: 'radial-gradient(900px 520px at 80% 14%, rgba(43,51,145,0.30), transparent 72%)' }} />

      <div className="relative flex-1 flex items-center pt-[88px] pb-6 w-full">
        <div className="max-w-[1500px] mx-auto w-full px-6 md:px-10 flex items-center min-h-[50svh] md:min-h-0">
          <h1 className="font-display font-medium text-[var(--text)] leading-[1.04] tracking-[-0.02em] text-[clamp(1.85rem,5.4vw,5.4rem)] w-full max-w-[28ch] [text-wrap:balance]">
            A studio designing and engineering experiences around people who{' '}
            <span className="font-serif-c italic font-normal text-[var(--accent)]">move through them.</span>
          </h1>
        </div>
      </div>

      {/* Ticker - in-flow, always pinned to the bottom of the viewport */}
      <div className="relative border-t border-[var(--border)] py-3.5 overflow-hidden flex items-center shrink-0">
        <div className="marquee-track flex-1">
          {Array.from({ length: 8 }).map((_, i) => (
            <span key={i} className="label !text-[var(--muted-2)] mx-8">{hero.ticker}</span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
